import React from 'react';
import { Disc3 } from 'lucide-react';

interface CatalogueHeaderProps {
    onCreateDerivative: () => void;
}

export const CatalogueHeader: React.FC<CatalogueHeaderProps> = ({
    onCreateDerivative,
}) => {
    return (
        <div className="text-center mt-24 mb-6">
            <h1 className="text-3xl font-semibold text-card-foreground">Fast Track</h1>
            <p className="text-sm text-muted-foreground mt-1">
                Upload an audio track and generate additional instrumentals. Turn loops, sketches and WIP songs into full productions.
            </p>
            <div className="mt-6 flex justify-center">
                <button
                    onClick={ onCreateDerivative }
                    className="btn-primary flex items-center gap-2"
                >
                    <Disc3 size={ 16 } />
                    New Fast Track
                </button>
            </div>
        </div>
    );
}; 